/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit One/view.blocks to change it.
import "DesignSystem/Fonts/Inter-500.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import Info from 'DesignSystem/Info/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function One({
  children,
  viewPath = "/App/Account/Content/Marketing/LocationChooser/Content/One",
  location
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<div
  data-testid="One.Vertical"
  data-view-path={viewPath}
 style={{'--mr-1-ll8': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<span
  data-testid="One.Text"
  data-view-path={viewPath}
 className={`views-text ${styles.Text}`}
>
location
</span>
<Info
  viewPath={`${viewPath}/Info`}
 marginLeft={8}
 marginTop={4}
 text={location}
/>
</div>
{children}
</React.Fragment>)
}